import axios from "@/axios.js";
import constants from "@/constants.js";
import _ from "lodash";
import coachConfigs from "@/assets/data/coach-configs.js";

export default {
  async createBoard({ commit }, boardObj) {
    try {
      const resObj = await axios.post(`${constants.apiHost}/boards`, boardObj);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardDetails({ commit }, _boardId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards/${_boardId}`);
      commit("SET_BOARD_CREATION_DETAILS", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserBoardData({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { userId },
      });
      if (resObj.data && resObj.data.data && resObj.data.data[0]) {
        const data = {
          _id: resObj.data.data[0]._id,
          youlabToken: resObj.data.data[0].youlabToken,
          progress: resObj.data.data[0].progress,
          youlabId: resObj.data.data[0].youlabId,
        };

        commit("SET_USER_BOARD_DATA", data);
      }

      return resObj;
    } catch (err) {
      throw err;
    }
  },
  async fetchAllBoards({ commit }, organizationId) {
    console.log("id", organizationId);
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards`, {
        params: { organizationId, status: "active" },
      });
      commit("SET_ALL_BOARDS", resObj.data.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllArchivedBoards({ commit }, organizationId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards`, {
        params: { organizationId, status: "deactivated" },
      });
      commit("SET_ALL_ARCHIVED_BOARDS", resObj.data.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardBySlug({ commit }, boardSlug) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards`, {
        params: { slug: boardSlug, status: "active" },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUniqueBoardUser({ commit }, { boardId, boardUserId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId, _id: boardUserId, status: "active" },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardById({ commit }, boardId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards/${boardId}`);
      commit("SET_CURRENT_BOARD", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async createBoardPaymentSession(
    { commit },
    { boardObj, organizationId, orgSlug }
  ) {
    try {
      // let rktChannel = {};
      // bypass rkt channel creation if orgSlug is not present
      // if (orgSlug && boardObj.installedApps && boardObj.installedApps.includes('comm-server')) {
      //   // Create Rkt Channel

      //   let rktPayload = {
      //     name: `${boardObj.title}_${boardObj.orgSlug}`,
      //     boardId: boardObj._boardId,
      //     members: boardObj.members
      //   };
      //   rktChannel = await axios.post(`${constants.commServiceUrl}/rkt/${orgSlug}/channel`, rktPayload);
      // }

      // Comm Server Channel Id
      // const rktChannelId = rktChannel.data && rktChannel.data.data ? rktChannel.data.data._id : '';

      const resObj = await axios.patch(
        `${constants.apiHost}/boards/${boardObj._boardId}`,
        {
          // rktChannelId,
          numberOfUsers: boardObj.numberOfUsers,
          numberOfMonths: boardObj.numberOfMonths,
          title: boardObj.title,
          installedApps: boardObj.installedApps,
          status: boardObj.status,
          slug: boardObj.slug,
          netMRP: boardObj.netMRP,
          rktChannelId: "",
          description: boardObj.description,
          skill: boardObj.skill,
          personality: boardObj.personality,
          perpetuality: boardObj.perpetuality,
          userVisibilityOption: boardObj.userVisibilityOption,
        }
      );

      // Add Board Owners
      // if(orgSlug && rktChannelId && !_.isEmpty(boardObj.members)) {
      //   boardObj.members.forEach(async member => {
      //     await axios.post(`${constants.commServiceUrl}/rkt/${orgSlug}/channel/owner`, {rktChannelId, ...member});
      //   });
      // }

      // log activity
      let actPayload = boardObj;
      actPayload["organizationId"] = organizationId;
      const logText = `Created a new Board - ${boardObj.title}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...actPayload });

      // log activity #iife
      // (() => {let actPayload = boardObj;
      // actPayload['organizationId'] = boardObj.organizationId;
      // const logText = `Connected ${boardObj.title} board with Comm Server`;
      // axios.post(`${constants.apiHost}/actvt-log`, {logText, ...actPayload});})();

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateBoard({ commit }, { boardObj, organizationId }) {
    // // console.log(boardObj);
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/boards/${boardObj._boardId}`,
        {
          numberOfUsers: boardObj.numberOfUsers,
          createPaymentSession: boardObj.createBoardPaymentSession,
          title: boardObj.title,
          installedApps: boardObj.installedApps,
          description: boardObj.description,
          skill: boardObj.skill,
          personality: boardObj.personality,
          userVisibilityOption: boardObj.userVisibilityOption,
          status: boardObj.status,
        }
      );

      // log activity
      let actPayload = boardObj;
      actPayload["organizationId"] = organizationId;
      const logText = `Updated Board Details - ${boardObj.title}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...actPayload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async deactivateBoard({ commit }, { boardId, boardTitle, organizationId }) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/boards/${boardId}`,
        {
          status: "deactivated",
        }
      );

      // log activity
      let actPayload = { boardId };
      actPayload["organizationId"] = organizationId;
      const logText = `Deactivated Board - ${boardTitle}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...actPayload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllBoardUsers({ commit }, boardId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId, status: "-deactivated" },
      });
      commit("SET_CURRENT_BOARD_USERS", resObj.data.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async _onlyFetchAllBoardUsers({ commit }, { boardId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId, status: "-deactivated" },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardUser({ commit }, { userId, boardId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { userId, boardId, status: "-deactivated" },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardUserByEmail({ commit }, { email, boardId }) {
    try {
      const userObj = await axios.get(`${constants.apiHost}/users`, {
        params: { email },
      });

      let boardUserObj = { data: { total: 0 } };
      if (userObj && userObj.data.total > 0) {
        boardUserObj = await axios.get(`${constants.apiHost}/board-users`, {
          params: { userId: userObj.data.data[0]._id, boardId },
        });
      }

      return boardUserObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOtherBoardUserByEmail({ commit }, { email }) {
    try {
      const userObj = await axios.get(`${constants.apiHost}/users`, {
        params: { email },
      });

      let boardUserObj = { data: { total: 0 } };
      if (userObj && userObj.data.total > 0) {
        boardUserObj = await axios.get(`${constants.apiHost}/board-users`, {
          params: { userId: userObj.data.data[0]._id },
        });
      }

      // console.log('user exists', boardUserObj);

      return boardUserObj;
    } catch (error) {
      throw error;
    }
  },
  async updateBoardView({ commit }, { boardId, boardView }) {
    // // console.log(boardObj);
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/boards/${boardId}`,
        {
          boardView: boardView,
        }
      );
      commit("SET_CURRENT_BOARD", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardMetaData({ commit }, { boardId }) {
    try {
      const resObj = await axios.get(
        `${constants.acticsServiceUrl}/anics/board/${boardId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async connectWithCommServer({ commit }, { boardObj, orgSlug }) {
    try {
      let rktChannel = {};
      // bypass rkt channel creation if orgSlug is not present
      if (orgSlug) {
        // Create Rkt Channel

        let rktPayload = {
          name: `${boardObj.title}`,
          boardId: boardObj.boardId,
        };
        rktChannel = await axios.post(
          `${constants.commServiceUrl}/rkt/${orgSlug}/channel`,
          rktPayload
        );

        // Comm Server Channel Id
        const rktChannelId =
          rktChannel.data && rktChannel.data.data
            ? rktChannel.data.data._id
            : "";

        if (rktChannelId) {
          const resObj = await axios.patch(
            `${constants.apiHost}/boards/${boardObj.boardId}`,
            {
              rktChannelId,
            }
          );
          commit("SET_CURRENT_BOARD", resObj.data);

          // Add Board Owners
          // if(!_.isEmpty(boardObj.members)) {
          //   boardObj.members.forEach(member => {
          //     axios.post(`${constants.commServiceUrl}/rkt/channel/owner`, {rktChannelId, ...member});
          //   });
          // }

          // log activity
          let actPayload = boardObj;
          actPayload["organizationId"] = boardObj.organizationId;
          const logText = `Connected ${boardObj.title} board with Comm Server`;
          axios.post(`${constants.apiHost}/actvt-log`, {
            logText,
            ...actPayload,
          });

          return resObj;
        }
      }

      throw new Error("Unexpected Error Occurred!");
    } catch (err) {
      throw err;
    }
  },
  async syncBoardChannel({ commit }, { membersObj, orgSlug }) {
    try {
      // Add Board Owners
      if (orgSlug && !_.isEmpty(membersObj.members)) {
        membersObj.members.forEach((member) => {
          axios.post(
            `${constants.commServiceUrl}/rkt/${orgSlug}/channel/owner`,
            member
          );
        });
      }
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////
  // Invite User on Board
  ////////////////////////////////////

  async fetchUserByEmail({ commit }, userObj) {
    try {
      const email = userObj.email;
      const resObj = await axios.get(`${constants.apiHost}/users`, {
        params: { email: email },
      });
      if (resObj.data.total === 0) {
        const organizationId = userObj.organizationId
          ? userObj.organizationId
          : "";
        const installedApps =
          userObj && userObj.installedApps ? userObj.installedApps : [];
        if (installedApps.includes("hibob") && organizationId) {
          let hibobUser = await axios.get(
            `${constants.hibobIntegrationServiceUrl}/user/${organizationId}/${email}`
          );
          hibobUser = hibobUser && hibobUser.data ? hibobUser.data : {};
          return {
            data: {
              data: [hibobUser],
              userFoundInHibob: true,
              total: Object.keys(hibobUser).length ? 1 : 0,
            },
          };
        }
      }
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardUserConfig({ commit }, { userId }) {
    try {
      const boardUserConfigObj = await axios.get(
        `${constants.apiHost}/board-users-config`,
        { params: { userId: userId } }
      );
      return boardUserConfigObj;
    } catch (error) {
      throw error;
    }
  },
  async addUserToBoard(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/boards/board-user`,
        payload
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateUserOnBoard(
    { commit },
    { userObj, boardUserObj, installedApps, createDuplicate, orgSlug }
  ) {
    try {
      // 1. Check if user data is already there in users table
      // console.log('Step 1');
      let userResObj = await axios.get(`${constants.apiHost}/users`, {
        params: { email: userObj.email },
      });

      // 2. If user is not there then create a new user and proceed else update user details and then move to step 3.
      // console.log('Step 2');
      if (userResObj.data && userResObj.data.total === 0) {
        userResObj = await axios.post(`${constants.apiHost}/users`, userObj);
        userResObj = userResObj.data;
      } else {
        userResObj = userResObj.data.data[0];

        // Update user details
        let userUpdateObj = {
          firstName: userObj.firstName,
          lastName: userObj.lastName,
          // dob: userObj.dob,
          gender: userObj.gender,
        };

        userResObj = await axios.patch(
          `${constants.apiHost}/users/${userResObj._id}`,
          userUpdateObj
        );
        userResObj = userResObj.data;
      }

      const bucObj = {
        ...boardUserObj,
        userId: userResObj._id,
        boardId: boardUserObj.boardId,
        boardTitle: boardUserObj.boardTitle,
      };

      // 2.1 Check if board config details are already present
      let boardUserConfigResObj = await axios.get(
        `${constants.apiHost}/board-users-config`,
        { params: { userId: userResObj._id } }
      );

      // 2.2 If board user config details are not found, create a new record
      if (
        boardUserConfigResObj.data &&
        boardUserConfigResObj.data.total === 0
      ) {
        boardUserConfigResObj = await axios.post(
          `${constants.apiHost}/board-users-config`,
          bucObj
        );
        boardUserConfigResObj = boardUserConfigResObj.data;
      } else {
        // 2.2 If board user config is already present, then update
        boardUserConfigResObj = await axios.patch(
          `${constants.apiHost}/board-users-config/${boardUserConfigResObj.data.data[0]._id}`,
          bucObj
        );
        boardUserConfigResObj = boardUserConfigResObj.data;
      }

      // Add user org config log (async)
      axios.post(
        `${constants.gatewayServiceUrl}/organization/organization-config-log`,
        {
          userId: userResObj._id,
          organizationId: boardUserObj.organizationId,
          data: bucObj,
        }
      );

      // // console.log(userResObj);
      const buObj = {
        ...boardUserObj,
        userId: userResObj._id,
        boardId: boardUserObj.boardId,
        boardTitle: boardUserObj.boardTitle,
        createDuplicate: createDuplicate,
      };

      // 3. Check if user is there in board users table { userId, boardId }
      // console.log('Step 3');
      let boardUserResObj = await axios.get(
        `${constants.apiHost}/board-users`,
        {
          params: {
            userId: userResObj._id,
            boardId: boardUserObj.boardId,
          },
        }
      );

      // 4. If user is not there, then create a new user in boardUsers
      // console.log('Step 4');
      if (boardUserResObj.data && boardUserResObj.data.total === 0) {
        // Redundant
        boardUserResObj = await axios.post(
          `${constants.apiHost}/board-users`,
          buObj
        );
        boardUserResObj = boardUserResObj.data;
      } else {
        // 5. If user is there then update user detaild
        // console.log('Step 5');
        boardUserResObj = await axios.patch(
          `${constants.apiHost}/board-users/${boardUserResObj.data.data[0]._id}`,
          buObj
        );
        boardUserResObj = boardUserResObj.data;
      }

      // Exceptional Configuration for Coach
      if (installedApps.includes("coach")) {
        // 1 Check if user is already present
        axios.post(`${constants.coachIntegrationServiceUrl}/user`, {
          firstName: userObj.firstName,
          lastName: userObj.lastName,
          email: userObj.email,
          userType: buObj.userType,
          gtbrddUserId: userResObj._id,
          gtbrddOrganizationId: boardUserObj.organizationId,
        });
      }

      // this will occur, if alex is not installed on board
      // console.log('Step 10');
      commit("UPDATE_BOARD_INVITEES", {
        userData: userResObj,
        ...boardUserResObj,
      });
      return {
        userData: userResObj,
        boardUserConfig: boardUserConfigResObj,
        ...boardUserResObj,
      };
    } catch (error) {
      throw error;
    }
  },
  async deactivateBoardUser({ commit }, { boardUserId, boardUserObj }) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/board-users/${boardUserId}`,
        { status: "deactivated" }
      );
      commit("DELETE_BOARD_INVITEE", resObj.data._id);

      // log activity
      let actPayload = { boardUserId, boardId: boardUserObj.boardId };
      actPayload["organizationId"] = boardUserObj.boardData.organizationId;
      const logText = `Removed user (${boardUserObj.userData.firstName} ${boardUserObj.userData.lastName}) from Board - ${boardUserObj.boardData.title}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...actPayload });

      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllUsersInBoard({ commit }, boardId) {
    try {
      // console.log(boardId);
      commit("SET_FETCHING_BOARD_USERS", true);
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId },
      });
      if (resObj && resObj.data && resObj.data.data) {
        commit("SET_CURRENT_BOARD_USERS", resObj.data.data.reverse());
      }
      commit("SET_FETCHING_BOARD_USERS", false);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllUsersInBoardV2({ commit }, boardId) {
    try {
      commit("SET_FETCHING_BOARD_USERS", true);
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/boards/board-users/meta/${boardId}`
      );
      if (resObj && resObj.data && resObj.data.data) {
        commit("SET_CURRENT_BOARD_USERS", resObj.data.data);
      }
      commit("SET_FETCHING_BOARD_USERS", false);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async searchBoardUsers({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/boards/board-user/search`,
        payload
      );
      if (resObj && resObj.data && resObj.data.data) {
        commit("SET_CURRENT_BOARD_USERS", resObj.data.data);
        commit("SET_SEARCHED_BOARD_USERS", true);
      }
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchLast3BoardInvites({ commit }, { boardId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId, onlyFetchLast3: true },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchLast3AlexInvites({ commit }, orgId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/alex`, {
        params: { organizationId: orgId },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async resendBoardInvitationLink({ commit }, invitationObj) {
    try {
      // Update user temp password
      const loginCode = Math.random().toString(36).substring(7);
      await axios.patch(`${constants.apiHost}/users/${invitationObj.userId}`, {
        password: loginCode,
      });

      invitationObj["loginCode"] = loginCode;
      const resObj = await axios.post(
        `${constants.apiHost}/mailer`,
        invitationObj
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  inviteFromExcel({ commit }, { inviteeFormData, boardId }) {
    try {
      const inviteeResArrayObj = axios.post(
        `${constants.apiHost}/async-board-user-invite`,
        inviteeFormData
      );
      return true;
    } catch (err) {
      throw err;
    }
  },
  async fetchBoardUserProcessingStatus({ commit }, { boardId }) {
    try {
      // console.log(boardId);
      const resObj = await axios.get(
        `${constants.apiHost}/process-board-user-invitees`,
        { params: { boardId } }
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async addToBoardChannel(
    { commit },
    { email, userId, name, boardId, boardUserId, rktChannelId }
  ) {
    try {
      const resObj = await axios.post(
        `${constants.commServiceUrl}/rkt/channel/member`,
        {
          email,
          userId,
          name,
          boardId,
          boardUserId,
          rktChannelId,
        }
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardUserProfileAnalytics({ commit }, boardUserId) {
    try {
      const resObj = await axios.get(
        `${constants.acticsServiceUrl}/anics/board-user/profile/${boardUserId}`
      );
      commit("SET_BOARD_USER_PROFILE_ANALYTICS", resObj.data.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationConfigLog({ commit }, { userId, organizationId }) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/organization/organization-config-log/${organizationId}/${userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////
  /// User Level Boards
  ////////////////////////

  async fetchUserLevelBoards({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { userId },
      });
      commit("SET_USER_LEVEL_BOARDS", resObj.data.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserLevelBoard({ commit }, boardId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/boards/${boardId}`);
      commit("SET_CURRENT_USER_LEVEL_BOARD", resObj.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchCurrentBoardUserDetails({ commit }, { userId, boardId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { userId, boardId },
      });
      commit("SET_CURRENT_BOARD_USER_DETAILS", resObj.data.data[0]);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async verifyBoardUserStatus({ commit }, boardUserId) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/board-users/${boardUserId}`,
        { status: "active" }
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async boardUserProgressUpdate({ commit }, data) {
    try {
      let _id = data._id;
      let progress = data.progress;
      const resObj = await axios.patch(
        `${constants.apiHost}/board-users/${_id}`,
        { progress: progress }
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async deleteSession({ commit }, userId) {
    try {
      await axios.delete(`${constants.apiHost}/board-users/${userId}`);
    } catch (err) {
      throw err;
    }
  },
  async fetchUserLevelBoardAnalytics({ commit }, boardUserId) {
    try {
      const resObj = await axios.get(
        `${constants.acticsServiceUrl}/anics/board-user/${boardUserId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserBoardProgress({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/board-user-anics/board-progress`,
        payload
      );
      commit("SET_CURRENT_BOARD_PROGRESS", resObj.data.data);
      return resObj.data.data.journey;
    } catch (error) {
      throw error;
    }
  },
  async assignCoach({ commit }, coachDetails) {
    try {
      const resObj = await axios.post(
        `${constants.coachIntegrationServiceUrl}`,
        coachDetails
      );
      commit("UPDATE_BOARD_USER_COACH", coachDetails);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async revealCoach({ commit }, coachDetails) {
    try {
      const resObj = await axios.post(
        `${constants.coachIntegrationServiceUrl}/reveal`,
        coachDetails
      );
      commit("UPDATE_BOARD_USER_COACH", coachDetails);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardUsersCoach({ commit }, boardId) {
    try {
      const resObj = await axios.get(
        `${constants.coachIntegrationServiceUrl}/?boardId=${boardId}`
      );
      commit("SET_BOARD_USER_COACH", resObj.data.data);
    } catch (error) {
      throw error;
    }
  },
  async fetchGalaAbilities({ commit }, { userId }) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/journey/gala/ability/${userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchBoardSteps(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/boards/board-steps/${payload.boardId}/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateBoardPrivacy(_, payload) {
    const resObj = await axios.post(
      `${constants.gatewayServiceUrl}/boards/board`,
      payload
    );
    return resObj.data;
  },
  async fetchBoardsByPrivacyType(_, privacyType) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/boards?&privacy=${privacyType}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateBoardStep(_, payload) {
    const resObj = await axios.post(
      `${constants.gatewayServiceUrl}/boards/board-users/step`,
      payload
    );
    return resObj.data;
  },

  async fetchUsersInBoard(_, boardId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/board-users`, {
        params: { boardId },
      });
      return resObj;
    } catch (error) {
      throw error;
    }
  },
};
